import { getScrollX, getScrollY, requestAnimationFrame } from '../ADNDHelpers'

import ADNDTargetsLayer from '../layers/ADNDTargetsLayer'

export function DEFAULT_PROPS() {
  return {
    acceptTypes: [],
    fetchData: function () {
      return null
    },
    node: null,
    rect: null,
    edge: null,
    dynamicPosition: false,
    zIndex: 0,
    entered: false,
    onEnterHandler: null,
    onLeaveHandler: null,
    onDropHandler: null,
    acceptDropFetcher: null
  }
}

export const PRIVATE = {
  doEnter(state) {
    this.props.entered = true
    if (this.props.onEnterHandler) {
      // this.props.onEnterHandler(this.PUBLIC, { type: state.item ? state.item.type : null })
      this.props.onEnterHandler(Object.assign({}, state.source?.PUBLIC ?? {}, this.PUBLIC), {
        type: state.item ? state.item.type : null
      })
    }
    return this.PRIVATE
  },
  doLeave(state) {
    this.props.entered = false
    if (this.props.onLeaveHandler) {
      this.props.onLeaveHandler(this.PUBLIC, { type: state.item ? state.item.type : null })
    }
    return this.PRIVATE
  },
  acceptDrop(type) {
    return this.props.acceptDropFetcher ? this.props.acceptDropFetcher(type, this.PUBLIC) : true
  },
  fetchRect(scrollX = getScrollX(), scrollY = getScrollY()) {
    if (null != this.props.node) {
      const rect = this.props.node.getBoundingClientRect()
      this.props.rect = {
        left: rect.left + scrollX - (this.props.edge?.left || 0),
        right: rect.right + scrollX + (this.props.edge?.right || 0),
        top: rect.top + scrollY - (this.props.edge?.top || 0),
        bottom: rect.bottom + scrollY + (this.props.edge?.bottom || 0),
        width: rect.width || rect.right - rect.left,
        height: rect.height || rect.bottom - rect.top
      }
    }
    return this.PRIVATE
  },
  doDrop(state, event) {
    if (this.props.onDropHandler) {
      const data = this.PRIVATE.fetchData(state, event)
      if (null != data) {
        const target = this
        requestAnimationFrame(function () {
          if (target.props.onDropHandler) {
            target.props.onDropHandler.apply(target, data)
          }
        })
      }
    }
    return this.PRIVATE
  },
  fetchData(/*state, event*/) {
    return null
  }
}

export const PUBLIC = {
  clone(withProps = {}) {
    return ADNDDropTarget(Object.assign({}, this.props, withProps))
  },
  connect(node, { dynamicPosition, acceptTypes, zIndex } = {}) {
    if (node != this.props.node) {
      if (null != node) {
        const target = this
        this.props.acceptTypes.forEach(function (type) {
          ADNDTargetsLayer().addTarget(type, target)
        })
      } else {
        this.PUBLIC.disconnect()
      }
      this.props.node = node
    }
    if (null != dynamicPosition) {
      this.props.dynamicPosition = dynamicPosition
    }
    if (null != acceptTypes) {
      this.props.acceptTypes = acceptTypes
    }
    if (null != zIndex) {
      this.props.zIndex = zIndex
    }
    return this.PUBLIC
  },
  disconnect() {
    if (null != this.props.node) {
      const target = this
      this.props.acceptTypes.forEach(function (type) {
        ADNDTargetsLayer().removeTarget(type, target)
      })
      this.props.node = null
    }
    return this.PUBLIC
  },
  isConnected() {
    return null != this.props.node
  },
  connectedNode() {
    return this.props.node
  },
  onEnter(onEnterHandler) {
    if ('function' == typeof onEnterHandler) {
      this.props.onEnterHandler = onEnterHandler
    }
    return this.PUBLIC
  },
  onLeave(onLeaveHandler) {
    if ('function' == typeof onLeaveHandler) {
      this.props.onLeaveHandler = onLeaveHandler
    }
    return this.PUBLIC
  },
  acceptDrop(acceptDropFetcher) {
    if ('function' == typeof acceptDropFetcher) {
      this.props.acceptDropFetcher = acceptDropFetcher
    }
    return this.PUBLIC
  },
  onDrop(onDropHandler) {
    if ('function' == typeof onDropHandler) {
      this.props.onDropHandler = onDropHandler
    }
    return this.PUBLIC
  },
  setEdges(top = 0, right = 0, bottom = 0, left = 0) {
    this.props.edge = { top, right, bottom, left }
    return this.PUBLIC
  }
}

export function extendADNDDropTarget(props = {}, defaultProps = DEFAULT_PROPS()) {
  const ADNDDropTarget = {
    props: Object.assign({}, defaultProps, props)
  }

  ADNDDropTarget.PRIVATE = {
    doEnter: PRIVATE.doEnter.bind(ADNDDropTarget),
    doLeave: PRIVATE.doLeave.bind(ADNDDropTarget),
    acceptDrop: PRIVATE.acceptDrop.bind(ADNDDropTarget),
    fetchRect: PRIVATE.fetchRect.bind(ADNDDropTarget),
    doDrop: PRIVATE.doDrop.bind(ADNDDropTarget),
    fetchData: PRIVATE.fetchData.bind(ADNDDropTarget)
  }

  ADNDDropTarget.PUBLIC = {
    clone: PUBLIC.clone.bind(ADNDDropTarget),
    connect: PUBLIC.connect.bind(ADNDDropTarget),
    disconnect: PUBLIC.disconnect.bind(ADNDDropTarget),
    isConnected: PUBLIC.isConnected.bind(ADNDDropTarget),
    connectedNode: PUBLIC.connectedNode.bind(ADNDDropTarget),
    onEnter: PUBLIC.onEnter.bind(ADNDDropTarget),
    onLeave: PUBLIC.onLeave.bind(ADNDDropTarget),
    acceptDrop: PUBLIC.acceptDrop.bind(ADNDDropTarget),
    onDrop: PUBLIC.onDrop.bind(ADNDDropTarget),
    setEdges: PUBLIC.setEdges.bind(ADNDDropTarget)
  }

  return ADNDDropTarget
}

export default function ADNDDropTarget(props) {
  return extendADNDDropTarget(props).PUBLIC
}
